<template>
  <ion-page>
    <ion-header class="privacy-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="goBack">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Удаление аккаунта</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background privacy-content" :fullscreen="true">
      <div class="privacy-body ion-padding">
        <p class="privacy-intro">
          На этой странице описано, как пользователь мобильного приложения «Лига тренеров» (com.growapp.ligaapp)
          может запросить удаление аккаунта и связанных с ним персональных данных.
        </p>

        <h2>1. Удаление в приложении</h2>
        <p>
          Если у вас установлено приложение и вы можете войти в аккаунт:
        </p>
        <ol class="steps-list">
          <li>Откройте приложение «Лига тренеров» и войдите в аккаунт.</li>
          <li>Перейдите в раздел <strong>«Личный кабинет»</strong> (меню приложения).</li>
          <li>Нажмите кнопку <strong>«Удалить аккаунт»</strong> и подтвердите действие.</li>
        </ol>
        <p>
          После подтверждения аккаунт и связанные с ним данные в приложении будут удалены без возможности восстановления.
        </p>

        <h2>2. Запрос по электронной почте</h2>
        <p>
          Если приложение удалено или вы не можете войти в аккаунт, направьте запрос на удаление на адрес:
        </p>
        <p>
          <a :href="'mailto:' + contactEmail + '?subject=' + encodeURIComponent(mailSubject)" class="privacy-link">{{ contactEmail }}</a>
        </p>
        <p>Укажите в письме:</p>
        <ul class="steps-list">
          <li>адрес электронной почты, привязанный к аккаунту;</li>
          <li>логин (если помните);</li>
          <li>текст запроса на удаление аккаунта и персональных данных.</li>
        </ul>
        <p>
          Мы обработаем запрос в разумный срок и сообщим о результате на указанный e-mail.
        </p>

        <h2>3. Какие данные удаляются</h2>
        <p>При удалении аккаунта удаляются или обезличиваются, в частности:</p>
        <ul class="steps-list">
          <li>учётная запись (логин, e-mail, имя и фамилия, номер телефона);</li>
          <li>данные профиля и настройки в приложении;</li>
          <li>сессии авторизации на устройствах;</li>
          <li>данные о прогрессе и активности, привязанные к аккаунту в приложении.</li>
        </ul>

        <h2>4. Какие данные могут сохраняться</h2>
        <p>
          Отдельные сведения могут храниться дольше, если это требуется законом или необходимо для исполнения
          обязательств (например, документы и записи о платежах за платные услуги — в сроки, установленные
          законодательством РФ). Такие данные не используются для иных целей.
        </p>

        <h2>5. Дополнительно</h2>
        <p>
          С политикой обработки персональных данных можно ознакомиться на странице
          <router-link to="/privacy-policy" class="privacy-link">Политика конфиденциальности</router-link>.
        </p>

        <p class="privacy-footer">
          Оператор: Национальная лига тренеров<br />
          E-mail: <a :href="'mailto:' + contactEmail" class="privacy-link">{{ contactEmail }}</a>
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { LEGAL } from '@/config/legal';

export default defineComponent({
  name: 'AccountDeletion',
  components: {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  setup() {
    const router = useRouter();
    const contactEmail = LEGAL.payee.email;
    const mailSubject = 'Запрос на удаление аккаунта — Лига тренеров';

    const goBack = () => {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.push('/login');
      }
    };

    return {
      arrowBackOutline,
      contactEmail,
      mailSubject,
      goBack,
    };
  },
});
</script>

<style scoped>
.privacy-header ion-toolbar {
  --background: var(--ion-color-dark);
  --color: #fff;
}
.privacy-header ion-title {
  color: #fff;
}
.privacy-header ion-button,
.privacy-header ion-icon {
  --color: var(--ion-color-orange);
  color: var(--ion-color-orange);
}

.privacy-content {
  --background: var(--ion-background-color);
}
.privacy-body {
  max-width: 720px;
  margin: 0 auto;
  color: var(--ion-text-color);
  line-height: 1.6;
}
.privacy-intro {
  font-weight: 500;
  margin-bottom: 1.2em;
}
.privacy-body h2 {
  font-size: 1.1rem;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: var(--ion-color-orange);
}
.privacy-body p {
  margin-bottom: 0.8em;
}
.steps-list {
  margin: 0.5em 0 1em 1.2em;
  padding: 0;
}
.steps-list li {
  margin-bottom: 0.45em;
}
.privacy-link {
  display: inline;
  color: var(--ion-color-orange);
  word-break: break-all;
}
.privacy-footer {
  margin-top: 2em;
  opacity: 0.85;
  font-size: 0.95rem;
  line-height: 1.5;
}
</style>
